import { createSlice } from "@reduxjs/toolkit";
import { LocationState } from "./interfaces";
import { reducers } from "./syncReducers";

const initialState: LocationState = {
    loading: false,
    dynsCards: [],
    field: "",
    fieldActivities: [],
    wellboreDiagram: [],
    fluidLevels: [],
    locationId: "",
    method: "",
    projectId: "",
    locationName: "",
    locationSetPoints: [],
    locationTags: [],
    pot: 0,
    requirements: [],
    optimizationRequirements: [],
    files: [],
    zone: "",
    lastStatusConditions: {},
    waterTests: [],
    categoriesChanges: [],
    subsurfaceJobs: [],
    updatedFrom: "",
    attachments:[],
    productionAcumulated: [],
    productionTests: [],
    locationSteamEventHistory: [],
    technicalMeetDiscussionsSorted: [],
};

export const LocationSlice = createSlice({
    name: "main",
    initialState,
    reducers,
});
